const en_US = {
  "hyvendor.img.login": "images/img-bb.jpg",
  "hyvendor.header": "HyVendor Service",
  "hyvendor.title.login": "Login",
  "hyvendor.title.cust": "My Account",
  "hyvendor.title.book": "Book",
  "hyvendor.title.open": "Open",
  "hyvendor.title.admin": "Admin",
  "hyvendor.title.adminin": "In",
  "hyvendor.title.adminout": "Out",
  "hyvendor.title.adminall": "Adjust",
  "hyvendor.menu.renew": "Renew",
  "hyvendor.menu.renewed": "Renewed",
  "hyvendor.menu.loanlist": "Loan List",
  "hyvendor.menu.reservedlist": "Reserved List",
  "hyvendor.menu.admin": "Admin",
  "hyvendor.menu.adminin": "In",
  "hyvendor.menu.adminout": "Out",
  "hyvendor.menu.adminall": "Adjust",
  "hyvendor.column.second": " sec.",
  "hyvendor.column.title": "Title",
  "hyvendor.column.author": "Author",
  "hyvendor.column.publisher": "Publisher",
  "hyvendor.column.edition": "Edition",
  "hyvendor.column.barcode": "Barcode",
  "hyvendor.column.callnumber": "Callnumber",
  "hyvendor.column.keepdate": "Keep Date",
  "hyvendor.column.vailddate": "Vaild Date",
  "hyvendor.column.bookorder": "Book Order",
  "hyvendor.column.duedate": " (Due Date)",
  "hyvendor.column.day": " days",
  "hyvendor.column.locker": "Door ",
  "hyvendor.column.overdue": "Overdue ",
  "hyvendor.column.keepsitename": "Keepsite",
  "hyvendor.column.readercode": "Account",
  "hyvendor.column.readername": "Name",
  "hyvendor.column.bookinfo": "Book Info",
  "hyvendor.column.abstract": "Abstract",
  "hyvendor.button.next": "Next",
  "hyvendor.button.reset": "Reset",
  "hyvendor.button.cancel": "Cancel",
  "hyvendor.button.ok": "OK",
  "hyvendor.button.close": "Close",
  "hyvendor.button.cancelexit": "Exit",
  "hyvendor.button.donein": "Done",
  "hyvendor.button.doneout": "Done",
  "hyvendor.button.open": "Open",
  "hyvendor.button.login": "Login",
  "hyvendor.button.take": "Lend",
  "hyvendor.button.usekeyinlogin": "Login",
  "hyvendor.button.lend": "Lend",
  "hyvendor.button.cust": "My Account",
  "hyvendor.button.procout": "Proc Out",
  "hyvendor.button.procin": "Proc In",
  "hyvendor.button.donecontinue": "Continue",
  "hyvendor.button.donetake": "Done",
  "hyvendor.placeholder.password": "Password",
  "hyvendor.placeholder.username": "Username",
  "hyvendor.status.renew": "Renew",
  "hyvendor.status.unrenewable": "Unrenewable",
  "hyvendor.status.renewed": "Renewed",
  "hyvendor.status.load": "Selected",
  "hyvendor.status.ready": "Ready",
  "hyvendor.status.empty": "Empty",
  "hyvendor.status.opened": "Opened",
  "hyvendor.status.error": "Error",
  "hyvendor.status.maintain": "Maintain",
  "hyvendor.message.book": "",
  "hyvendor.message.renew":
    "Review your renew information. Click OK for continue.",
  "hyvendor.message.forgotcard": "Forgot Student / Staff Card?",
  "hyvendor.message.logininfo":
    "Please Tag Your Student / Staff Card on Card Reader for Login.",
  "hyvendor.message.open1": "The doors are opened!",
  "hyvendor.message.open2":
    "please make sure all doors closed after books to be take out, thank you.",
  "hyvendor.error.login": "Login failed!",
  "hyvendor.error.noselected": "No Select!",
  "hyvendor.error.syserror": "System Error!",
  "hyvendor.error.dooropened": "Please close the door!",
  "hyvendor.error.nobook": "No this book",
  "hyvendor.error.bookstatus": "This book status is not for proc in.",
  "hyvendor.footer":
    "Need help? please press &quot;Call&quot; button. Tel: 02-28221781, 02-28228684",
  "hyvendor.soldout": "SOLD OUT!",
};

export default en_US;
